import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ORDER_FEATURE } from '@b2b/features/order/core/store/order.states';
import { orderReducer } from '@b2b/features/order/core/store/order.reducer';
import { OrderEffects } from '@b2b/features/order/core/store/order.effect';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(ORDER_FEATURE, orderReducer),
    EffectsModule.forFeature([OrderEffects]),
  ],
})
export class OrderStoreModule {}
